(function (appComponents) {

	appComponents.services.visistat = function (Components) {

		var visistat = {};

		Components.getControllerPrototype().extend(visistat);

		visistat.firstRun = true;

		visistat.types = {

			VSCapture: function () {

				if (visistat.firstRun) {
					visistat.firstRun = false;
					return;
				}

				var pagesToExcludeFromSend = ["productDetails"];

				if (pagesToExcludeFromSend.indexOf(visistat._page.title) > -1) return;

				try {
					window.VSCapture();
				} catch (e) {
					console.log(e);
				}
			}

		};

		visistat.send = function (type) {
			if (!visistat._config.isVisistatEnabled) return;
			if (type == null || visistat.types[type] == null) return;
			visistat.types[type]();
		};

		visistat.init = function () {

		};

		return visistat;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});